import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    [
      _c(
        VAppBar,
        {
          staticClass: "pricing-toolbar elevation-6",
          class: {
            warning: _vm.notUsingLocalDatabase,
            ..._vm.configurableNavbarColor,
          },
          attrs: { app: "" },
        },
        [
          _c(
            VToolbarItems,
            [
              _c(
                VBtn,
                {
                  staticClass: "subheading font-weight-bold home-link",
                  attrs: { exact: "", text: "", to: "/", depressed: "" },
                },
                [
                  _c(VImg, {
                    staticStyle: { visibility: "invisible" },
                    attrs: {
                      id: "client-logo",
                      src: "/organisation-assets/logo.png",
                    },
                    on: { load: _vm.logoLoaded },
                  }),
                  _vm._v(" "),
                  _c(VImg, {
                    attrs: { src: _vm.pricingLogo, width: "12rem" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(VSpacer),
          _vm._v(" "),
          _vm._l(_vm.routes, function (route, index) {
            return _c(
              VToolbarItems,
              { key: index },
              [
                route.meta && route.meta.featureFlag
                  ? [
                      _c(
                        "feature-toggle",
                        { attrs: { toggle: route.meta.featureFlag } },
                        [
                          _c("main-navbar-tab", {
                            attrs: {
                              route: route,
                              "is-work-package-selected":
                                _vm.isWorkPackageSelected,
                              "is-navbar-highlighted": _vm.isNavbarHighlighted,
                              index: index,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  : _c("main-navbar-tab", {
                      attrs: {
                        route: route,
                        "is-work-package-selected": _vm.isWorkPackageSelected,
                        "is-navbar-highlighted": _vm.isNavbarHighlighted,
                        index: index,
                      },
                    }),
              ],
              2
            )
          }),
          _vm._v(" "),
          _c(VSpacer),
          _vm._v(" "),
          _c(
            VToolbarItems,
            [
              _vm.isAdmin
                ? _c(
                    VBtn,
                    {
                      staticClass: "text-none subheading settings-link",
                      attrs: {
                        id: "navbar-settings",
                        text: "",
                        exact: "",
                        to: "/admin",
                        depressed: "",
                      },
                    },
                    [_c("span", [_vm._m(0)], 1)]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            VToolbarItems,
            [
              _c(
                VMenu,
                {
                  attrs: { "offset-y": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on }) {
                        return [
                          _c(
                            VBtn,
                            _vm._g(
                              {
                                staticClass: "user-menu",
                                attrs: { text: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.isExpanded = !_vm.isExpanded
                                  },
                                },
                              },
                              on
                            ),
                            [
                              _c(
                                VAvatar,
                                {
                                  staticClass: "avatar",
                                  attrs: {
                                    height: "4rem",
                                    width: "4rem",
                                    color: "primary",
                                    size: "36",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "white--text headline" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.profileNameAndInitials.initials
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "name-text link",
                                  class: {
                                    "link-dark": _vm.isNavbarHighlighted,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.profileNameAndInitials.fullName)
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("main-expand-button", {
                                attrs: {
                                  "is-expanded": _vm.isExpanded,
                                  background: _vm.isNavbarHighlighted,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c(
                    VList,
                    [
                      _c(
                        VListItem,
                        [
                          _c(
                            VListItemTitle,
                            [
                              _c(
                                VBtn,
                                {
                                  staticClass: "text-none subheading nav-link",
                                  attrs: {
                                    id: "navbar-logout",
                                    text: "",
                                    depressed: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onLogout()
                                    },
                                  },
                                },
                                [
                                  _c("span", { staticClass: "align-bottom" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.startCase(_vm.$t("actions.logout"))
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm.shouldShowWorkpackageSelection
        ? _c(
            VAppBar,
            { staticClass: "workpackage-selection", attrs: { app: "" } },
            [
              _c(
                VLayout,
                {
                  staticClass: "flex-nowrap",
                  attrs: { row: "", "align-center": "" },
                },
                [
                  _c(
                    VFlex,
                    {
                      attrs: {
                        xs: _vm.isCompetitorSimulationEnabled ? 1 : 2,
                        description: "",
                      },
                    },
                    [
                      _c(
                        "tooltip",
                        {
                          attrs: {
                            value: _vm.selectedWorkpackage.description,
                            position: "bottom",
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "text-no-wrap",
                              on: { click: _vm.goToWorkpackages },
                            },
                            [
                              _vm._m(1),
                              _vm._v(" "),
                              _vm.dateHasPassed(
                                _vm.selectedWorkpackage.goLiveDate
                              )
                                ? _c("span", [
                                    _vm._v(
                                      "\n              (" +
                                        _vm._s(
                                          _vm.$t("workPackages.archived")
                                        ) +
                                        ")\n            "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm._f("truncate")(
                                      _vm.selectedWorkpackage.description,
                                      _vm.workpackageTruncationLength
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    VFlex,
                    {
                      attrs: { xs: _vm.isCompetitorSimulationEnabled ? 1 : 2 },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.selectedWorkpackage.storeFormat) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    VFlex,
                    {
                      staticClass: "text-xs-right",
                      attrs: { xs2: "", dates: "" },
                    },
                    [
                      _c(
                        "feature-toggle",
                        { attrs: { toggle: "enableReferenceDate" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("workPackages.referenceDate")) +
                              ":\n          "
                          ),
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.referenceDate) +
                                "\n          "
                            ),
                          ]),
                          _vm._v("\n          / "),
                          _c("br"),
                        ]
                      ),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("workPackages.completionDate")) +
                          ":\n        "
                      ),
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.completionDate) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(
                        "\n        / " +
                          _vm._s(_vm.$t("workPackages.goLiveDate")) +
                          ":\n        "
                      ),
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatLocalisedDate(
                                _vm.selectedWorkpackage.goLiveDate
                              )
                            ) +
                            "\n        "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isCompetitorSimulationEnabled
                    ? [
                        _c(
                          VFlex,
                          { attrs: { xs1: "" } },
                          [
                            _c(
                              "tooltip",
                              {
                                attrs: {
                                  value: _vm.$t(
                                    "gridView.engineRunWithSimulatedCompetitorPrices"
                                  ),
                                  position: "bottom",
                                },
                              },
                              [
                                _c(VSwitch, {
                                  staticClass: "pt-0",
                                  attrs: {
                                    id: "competitor-simulation-switch",
                                    loading:
                                      _vm.isUpdatingUseSimulatedCompetitorPrices,
                                    disabled:
                                      _vm.isUpdatingUseSimulatedCompetitorPrices,
                                    label: _vm.$t("gridView.engineSimulated"),
                                    primary: "",
                                    dense: "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.toggleCompetitorSimulation(
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.selectedWorkpackage
                                        .useSimulatedCompetitorPrices,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.selectedWorkpackage,
                                        "useSimulatedCompetitorPrices",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "selectedWorkpackage.useSimulatedCompetitorPrices",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    VFlex,
                    {
                      attrs: { xs: _vm.isCompetitorSimulationEnabled ? 3 : 3 },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "actions mr-2" },
                        [_c("navbar-engine-controls")],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    VFlex,
                    {
                      attrs: { xs: _vm.isCompetitorSimulationEnabled ? 4 : 3 },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-center" },
                        [
                          _c(
                            "feature-toggle",
                            {
                              attrs: {
                                toggle: _vm.enableWorkpackageSettingsModal,
                              },
                            },
                            [
                              _c("workpackage-settings-modal", {
                                attrs: { workpackage: _vm.selectedWorkpackage },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.displayAlerts() ? _c("alerts") : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(VIcon, { attrs: { color: "primary" } }, [_vm._v("mdi-cog")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      VIcon,
      { staticClass: "font-weight-bold", attrs: { color: "primary" } },
      [_vm._v(" chevron_left ")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }